import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { rutaDe, rutaSelector } from './rutasConsola';

/**
 * `/dashboard` sigue existiendo como redirección: el backend aterriza ahí
 * tras el OAuth de Instagram (`/dashboard?ig_oauth=…`), el Dashboard lee esa
 * query al montar, y habrá marcadores guardados. Por eso conserva la query.
 */
export function RedireccionDashboard() {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: rutaSelector(), search, hash }} replace />;
}

/** La antigua página de comentarios de Instagram es hoy una sección del bot. */
export function RedireccionComentariosInstagram() {
  const { botId } = useParams();
  return <Navigate to={rutaDe({ botId, seccion: 'comentarios-ig' })} replace />;
}
